js_wine_price()
function js_wine_price(){
    document.addEventListener('DOMContentLoaded', initWinePrice)
}

// mostrar o no tags precio en wine assistant
function initWinePrice() {
    const contexts = document.querySelectorAll('.js-wine-price')

    if (contexts != null){
        init()
    }

    function init(){
        if (localStorage.wine_price == 'false') {
            contexts.forEach(context => {
                context.classList.add('d-none')
            })
        }
    }
}
